import { Component, Input, OnInit } from '@angular/core';

import { UserService } from '../../../services/core.user.service';
import { ProjectModel } from '../../../services/project.model.service';
import { ProjectService } from '../../../services/project.service';
import { UiService } from '../../../services/core.ui.service';

import * as _ from 'lodash';

@Component({
    selector: 'project-join-button',
    template: require('./project.join-button.component.html')
})
export class ProjectJoinButtonComponent implements OnInit {

    @Input() project: any = null;

	protected showButton = false;
	protected requestSent = false;

    constructor(
        private userService: UserService,
		private projectModel: ProjectModel,
		private projectService: ProjectService,
		private uiService: UiService,
    ) { }
    
    ngOnInit() {
		var hasUser = this.userService.session.hasUser();

		if (hasUser) {
			this.projectModel.isProjectMember(
				this.userService.session.getUnixName(), 
				this.project.unixName
			)
			.then((isProjectMember) => {
				this.showButton = (!isProjectMember && hasUser);
			}, () => {
				this.showButton = hasUser;
			});
	
			this.projectService.joinRequests(this.project.unixName)
			.then(
				(response) => {
					this.requestSent = _.get(response, 'items', []).length > 0;
				},
				function() {
					this.requestSent = false;
				}
			);
		}
	};

	requestJoin() {
		if (this.requestSent) return false;
		this.projectService.join(this.project.unixName)
		.then((response) => {
			this.uiService.message.showSuccess('Requested to join project');
			this.requestSent = true;
		}, (response) => {
			console.log(response);
			this.uiService.message.showError('Request to join project failed');
		})
	};
}